import React from "react";
import { BgButton } from "../../UI/register";
import { css } from "styled-components/macro";

function ResendBTN({ status, time, click }) {
  status = status === "active";
  return (
    <div>
      <BgButton
        onClick={status ? click : () => {}}
        css={css`
          border-radius: 0 5px 5px 0;
        `}
        disabled={!status}
      >
        درخواست مجدد کد
      </BgButton>
      <BgButton
        className={status ? "deactive" : null}
        as="span"
        css={css`
          width: 50px;
          border-radius: 5px 0 0 5px;
          line-height: 35px;
          height: auto;
          background: var(--color1);
        `}
      >
        {time}
      </BgButton>
    </div>
  );
}
export default ResendBTN;
